import { useEditColorCollectionsStore } from "../../../js/stores/edit-color-collections-store";
import { Dialog, DialogContent } from "../shared/modal";
import { EditColorCollectionContent } from "./edit-color-collection-content";

function EditColorCollectionDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent>
        <EditColorCollectionContent
          closeClickHandler={() => updateIsModalOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}

export function EditColorCollectionModal() {
  const isModalOpen = useEditColorCollectionsStore(
    (state) => state.isModalOpen
  );
  const updateIsModalOpen = useEditColorCollectionsStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <>
      {isModalOpen && (
        <EditColorCollectionDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
